import React from 'react'
import { Vertical, Texto } from '@gravitate-js/excalibrr'
import { Dropdown, Menu } from 'antd'
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons'
import classNames from 'classnames'

export const MultiSortColumn = ({
  title,
  className = 'pr-4 sortable py-3',
  align = 'right',
  changeSort,
  activeSort,
  sortDirection,
  sortableItems,
  flex = 1,
}) => {
  const columnActive = sortableItems.some((item) => item.value === activeSort)
  const isAscended = columnActive && sortDirection === 'asc'
  const isDescended = columnActive && sortDirection === 'desc'
  const menu = (
    <Menu>
      {sortableItems.map((type, i) => {
        const isActive = type.value === activeSort
        const showAsc = !isActive || (isActive && sortDirection === 'desc')
        return (
          <Menu.Item key={i} onClick={() => changeSort(type.value)}>
            Sort By {type.title}{' '}
            {showAsc ? (
              <ArrowUpOutlined className='ml-2' style={{ color: 'var(--theme-color-2)' }} />
            ) : (
              <ArrowDownOutlined style={{ color: 'var(--theme-error)' }} className='ml-2' />
            )}
          </Menu.Item>
        )
      })}
      {columnActive && (
        <Menu.Item onClick={() => changeSort(undefined)}>
          <Texto appearance='error'>Clear Sort</Texto>
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <Vertical className={classNames('sortable', className, { asc: isAscended }, { desc: isDescended })} flex={flex}>
      <Dropdown overlay={menu}>
        <a className='ant-dropdown-link'>
          <Texto
            style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
            weight='bold'
            className='text-ellipsis pr-3'
            appearance='medium'
            align={align}
          >
            {title}
          </Texto>
        </a>
      </Dropdown>
    </Vertical>
  )
}
